import { styled } from "styled-components";
import { PopupWrapper } from "../../../style";

export const ExpenditureWrapper = styled(PopupWrapper)`
  width: 958px;
  height: auto;
  border-radius: 13px;
  box-sizing: border-box;

  > .button {
    margin: 20px 40px;
    height: 48px;
    font-family: Pretendard;
    font-size: 15px;
    font-weight: 600;
    text-align: center;
    cursor: pointer;
    line-height: 48px;
    border-radius: 8px;
    background: #6436e7;
    color: #fff;
  }
`;

export const ExpenditureTable = styled.div`
  padding: 0 40px;

  .item {
    width: 8%;
  }

  .input {
    width: 20%;
  }

  .box {
    width: 10%;
  }
`;

export const ExpenditureTableHeader = styled.div`
  display: flex;
  margin-bottom: 8px;

  > .item {
    font-family: Pretendard;
    font-size: 11px;
    font-weight: 500;
    text-align: center;
  }
`;

export const ExpenditureTableBody = styled.div`
  display: flex;
  flex-direction: column;
  gap: 5px;
`;

export const ExpenditureItemWrapper = styled.div<{ border?: boolean }>`
  display: flex;
  align-items: center;
  background: #ecf0f3;
  border-radius: 11.47px;
  height: 40px;
  box-sizing: border-box;
  border: ${(p) => (p.border ? "1px solid #6436e7" : "none")};
  font-family: Pretendard;
  font-size: 11px;
  font-weight: 600;
  text-align: center;

  > .item {
    &.time {
      display: flex;
      justify-content: center;
      align-items: center;
    }

    &.input {
      display: flex;
      justify-content: center;
      align-items: center;
    }

    &.box {
      display: flex;
      justify-content: center;
      align-items: center;
      gap: 8px;

      .button {
        width: 50px;
        height: 23px;
        border-radius: 5.73px;
        background: #6436e7;
        font-family: Pretendard;
        font-size: 11px;
        font-weight: 500;
        line-height: 23px;
        text-align: center;
        color: #fff;
        cursor: pointer;

        &.red {
          background: #d91818;
        }

        &.gray {
          background: #bebebe;
        }

        &.purple {
          width: 100%;
        }
      }
    }
  }
`;

export const ExpenditureInput = styled.div<{ width?: number }>`
  > input {
    width: ${(p) => p.width}px;
    height: 22px;
    padding: 4px 6px 4px 6px;
    border-radius: 2.1px;
    border: 0.5px solid #b7b7b7;
    box-sizing: border-box;
    text-align: center;
    font-family: Pretendard;
    font-size: 11px;
    font-weight: 500;
  }

  > input:focus {
    border-color: rgb(112, 112, 112);
    outline: none;
  }
`;
